import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEVersion} from '../../../react-oe/oe-version';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEBayerTargetType, OEBayerTargets, OEBayerFeatureAccess, OEBayerStartSelectionData} from './oe-bayer-model';

export default class OEBayerCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEBayerTargetType.anatomy]:    {icon: OEIconCodes.bayer.anatomyTarget, titleId: 'target_menu_anatomy'},
            [OEBayerTargetType.bayer]:      {icon: OEIconCodes.bayer.bayerTarget, titleId: 'target_menu_bayer'},
            [OEBayerTargetType.surgery]:    {icon: OEIconCodes.bayer.surgeryTarget, titleId: 'target_menu_surgery'},
            [OEBayerTargetType.opti]:       {icon: OEIconCodes.bayer.optiTarget, titleId: 'target_menu_zeissOpti2'},
            [OEBayerTargetType.oct]:        {icon: OEIconCodes.bayer.octTarget, titleId: 'target_menu_humanEyeOCT'},
            [OETarget.effigosExplorerHelp]: {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OEBayerTargetType.anatomy, OEBayerTargetType.bayer, OEBayerTargetType.surgery, OEBayerTargetType.opti, OEBayerTargetType.oct, OETarget.effigosExplorerHelp];
        if(this.props.version == OEVersion.eyeOCT)  targetTypes = [OEBayerTargetType.anatomy, OEBayerTargetType.surgery, OEBayerTargetType.opti, OEBayerTargetType.oct, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEBayerTargets}
                featureAccess={OEBayerFeatureAccess}
                startSelectionData={OEBayerStartSelectionData}
            />
        );
    }
}